import React from 'react';
import Modal from "../../../../component/modal/ModalTemplate";
import * as apiUtil from '../../../../util/apiUtil';
import * as stringUtil from '../../../../util/stringUtil';
import button from "bootstrap/js/src/button";
import Loading from "../../../../component/loading/Loading";

class MessageDetailModal extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.onChangeRadio = this.onChangeRadio.bind(this);

        this.ajaxGetMsInfo = this.ajaxGetMsInfo.bind(this);

        this.state={
            loading: false,

            messageType: '',

            preview1: '',
            preview2: '',

            RCS: [],
            MMS: {},
        }
    }// end constructor

    componentDidMount() {
        this.ajaxGetMsInfo();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.channelList !== this.props.channelList) {
            const initialMessageType = this.props.channelList.length === 2 ? this.props.channelList[0] : '';
            this.setState({ messageType: initialMessageType });
        }
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    onChangeRadio(e) {
        this.setState({messageType: e.target.value});
    }// end onChangeRadio
    ajaxGetMsInfo() {
        const { cmpnUid } = this.props;
        const { preview2 } = this.state;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: `/api/bizchat/message/info/${cmpnUid}`,
            method: apiUtil.requestMethod.POST,
            success: async (result) => {
                result.rcs.map((rcs, index) => {
                    if (rcs.buttons) rcs.buttons =  JSON.parse(rcs.buttons);
                    if (rcs.urlLink){
                        rcs.urlLink = JSON.parse(rcs.urlLink);
                        rcs.urlLink.forEach((url, index) => {
                            const placeholder = `[URL분석${index + 1}]`;
                            rcs.msg = rcs.msg.replace(placeholder, url);
                        });
                    }
                    if(rcs.imgOrigId){
                        this.setState({preview1: rcs.imgOrigId });
                        this.setState({preview2: rcs.imgOrigId});
                    }
                });
                if (result.mms.urlLink){
                    result.mms.urlLink = JSON.parse(result.mms.urlLink);
                    result.mms.urlLink.forEach((url, index) => {
                        const placeholder = `[URL분석${index + 1}]`;
                        result.mms.msg = result.mms.msg.replace(placeholder, url);
                    });
                }
                /*초기 버전, MMS 는 등록되지 않기 때문에 file 이 따로 존재 X*/
                if(result.mms.fileInfo){
                    this.setState({ preview2: result.mms.fileInfo });
                }


                await this.setState({RCS: result.rcs, MMS: result.mms});
            }
        })
    }// end ajax

    renderPreviewMessage(message) {
        const escaped = (message || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

        return stringUtil.convertNewlineToBr(escaped);
    }

    render() {
        const { loading } = this.state;

        const { isOpen, onClose, channelList } = this.props;
        const { onChangeRadio } = this;

        const {RCS, MMS, messageType, preview1, preview2} = this.state;
        return(
            <Modal
                open={isOpen}
                handleClose={onClose}
                modalTitle={"메시지 내용 확인하기"}
                className={"react-modal"}
            >
                <Loading loading={loading}/>
                <div className="modal-body">
                    <div className="d-flex justify-content-center mb-3">
                        {channelList.length === 2 ?
                            channelList.map((channel, index) => (
                                <div key={index} className='me-2'>
                                    <label htmlFor={channel}>{channel}</label>
                                    <input name={"messageType"} type="radio" id={channel}
                                           value={channel} className='form-check-input ms-1'
                                           checked={messageType === channel}
                                    onChange={onChangeRadio}
                                    />
                                </div>
                            ))
                            :
                            channelList.map((channel, index) => (
                                <div key={index}>
                                    <p>{channel}</p>
                                </div>
                            ))}
                    </div>
                    <div className='phone-box'>
                        <div className='title'>
                            <small className='small'>미리보기</small>
                        </div>
                        <div className='phone-body p-2'>
                            <div>
                                {messageType === "RCS 이미지" ?
                                    preview1 !== '' && <img src={preview1} alt="이미지"/>
                                    :
                                    preview2 !== '' && <img src={preview2} alt="이미지"/>
                                }

                            </div>
                            {messageType.startsWith("RCS") ?
                                RCS.length > 0 && RCS[0].title &&
                                <h6>{RCS[0].title}</h6>
                                :
                                 MMS.title &&
                                <h6>{MMS.title}</h6>
                            }
                            <br/>
                            {messageType.startsWith("RCS") ?
                                RCS.length > 0 && RCS[0].msg &&
                                <small
                                    dangerouslySetInnerHTML={{ __html: this.renderPreviewMessage(RCS[0].msg)}}
                                ></small>
                                :
                                MMS.msg &&
                                <small
                                    dangerouslySetInnerHTML={{ __html: this.renderPreviewMessage(MMS.msg)}}
                                ></small>
                            }
                            <div className={"btn-area"}>
                                {messageType.startsWith("RCS") && RCS.length > 0 && RCS[0].buttons &&
                                RCS[0].buttons.map((button, index) => (
                                <button key={index}
                                        className={index === 0 ? "btn btn-light btn-sm w-100 my-2" : "btn btn-light btn-sm w-100 mb-2"}>
                                    {button.name}
                                </button>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal-footer justify-content-center"}>
                    <button className={"btn btn-primary btn-md"} onClick={onClose}>확인</button>
                </div>
            </Modal>
        )
    }// end render
}// end class

export default MessageDetailModal;
